import React from 'react'
import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/arrow-left-line.svg'

type SvgProps = React.ComponentProps<typeof SvgComponent>

const Svg: React.FC<SvgProps> = (props) => <SvgComponent {...props} />

const Icon = withSvgProps(Svg)

export const ArrowLeftLine: React.FC<React.ComponentProps<typeof Icon>> = (
  props,
) => <Icon {...props} fill="none" stroke />
